<template>
  <div class="canvas-container" :class="[device, {'rotation': hasRotation}]">
    <canvas width="1800" height="350" id="hose-canvas" ref="hoseCanvas"></canvas>

    <hover-popup-coupling
        v-if="!this.isMobile && hoveredCoupling"
        :coupling="hoveredCoupling"
        :coupling-label="this.hovers.left.hovered ? 'A' : 'B'"
    ></hover-popup-coupling>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import HoverPopupCoupling from "@/components/hose/components/HoverPopupCoupling";
import { getFromStorage } from "@/helpers/backendStorage";

const centerMargin = 150;

export default {
  name: "CanvasImage",

  components: {
    HoverPopupCoupling,
  },

  props: {
    couplingA: {
      type: Object,
    },
    couplingB: {
      type: Object,
    },
    hose: {
      type: Object,
    },
  },

  data() {
    return {
      images: {},
      mouseX: null,
      mouseY: null,
      drawn: false,
    }
  },

  methods: {
    getImage(url) {
      if (this.images[url]) {
        return this.images[url];
      }

      const img = new Image();
      img.src = url;
      img.setAttribute('crossorigin', 'anonymous');
      this.images[url] = img;

      return img;
    },

    isImageLoaded(image) {
      return image.complete && image.naturalHeight !== 0;
    },

    draw() {
      if (!this.canvas || !this.ctx) {
        this.$forceUpdate();
        requestAnimationFrame(this.draw);
        return;
      }

      // set canvas size
      this.canvas.height = this.hasRotation ? 450 : 350;

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.canvas.style.cursor = 'default';

      if (!this.isMobile) {
        this.drawLine();
      }

      if (this.hose) {
        this.drawImage(getFromStorage(this.hose.render_image));
      }

      if (this.couplingA) {
        this.drawCouplingA();
      }
      if (this.couplingB) {
        this.drawCouplingB();
      }

      // if (this.hovers.left.hovered) {
      //   this.drawRectangle(
      //       this.hovers.left.x,
      //       this.hovers.left.y,
      //       this.hovers.left.w,
      //       this.hovers.left.h,
      //       'rgba(0, 255, 0, 0.1)'
      //   );
      // } else {
      //   this.drawRectangle(
      //       this.hovers.left.x,
      //       this.hovers.left.y,
      //       this.hovers.left.w,
      //       this.hovers.left.h,
      //       'rgba(0, 0, 255, 0.1)'
      //   );
      // }
      // if (this.hovers.right.hovered) {
      //   this.drawRectangle(
      //       this.hovers.right.x,
      //       this.hovers.right.y,
      //       this.hovers.right.w,
      //       this.hovers.right.h,
      //       'rgba(0, 255, 0, 0.1)'
      //   );
      // } else {
      //   this.drawRectangle(
      //       this.hovers.right.x,
      //       this.hovers.right.y,
      //       this.hovers.right.w,
      //       this.hovers.right.h,
      //       'rgba(0, 0, 255, 0.1)'
      //   );
      // }

      if (this.hovers.left.hovered || this.hovers.right.hovered) {
        this.canvas.style.cursor = 'pointer';
      }

      // if (this.mouseX && this.mouseY) {
      //   const factorX = 1800 / this.canvas.getBoundingClientRect().width;
      //   const factorY = 250 / this.canvas.getBoundingClientRect().height;
      //
      //   this.drawRectangle(this.mouseX * factorX, this.mouseY * factorY, 5, 5, 'rgba(255, 0, 0, 0.5)');
      // }

      this.drawn = true;
      requestAnimationFrame(this.draw);
    },

    drawImage(url, rotated = false) {
      if (url === undefined) return;
      let newUrl = url.replace('/storage/', '/canvas/');
      const img = this.getImage(newUrl);

      if (this.isImageLoaded(img)) {
        let y = this.canvas.height - img.height;
        // y = y - (img.height / 2);
        // y = y + ( / 2);
        // y = y + (this.hasRotation ? 60 : 30);

        if (rotated) {
          this.ctx.save();
          this.ctx.scale(-1, 1);
          this.ctx.drawImage(img, 0, y, this.canvas.width * -1, img.height);
          this.ctx.restore();
        } else {
          this.ctx.drawImage(img, 0, y, this.canvas.width, img.height);
        }
      }
    },

    drawLine() {
      this.ctx.beginPath();

      const endX = this.canvas.width - centerMargin;

      //horizontal line
      this.ctx.moveTo(centerMargin, 25);
      this.ctx.lineTo(endX, 25);

      //right line
      this.ctx.moveTo(endX, -60);
      this.ctx.lineTo(endX, 50);

      //left line
      this.ctx.moveTo(centerMargin, -60);
      this.ctx.lineTo(centerMargin, 50);

      this.ctx.lineWidth = 2;
      this.ctx.strokeStyle = '#3DB0C7';

      this.ctx.closePath();
      this.ctx.stroke();

      //dotted line
      this.drawDottedLine();
    },

    drawDottedLine() {
      this.ctx.beginPath();

      const endX = this.canvas.width - centerMargin;

      //left
      this.ctx.moveTo(centerMargin, 25);
      this.ctx.lineTo(centerMargin, 160);

      //right
      this.ctx.moveTo(endX, 25);
      this.ctx.lineTo(endX, 160);

      this.ctx.setLineDash([1, 5]);
      this.ctx.strokeStyle = '#3DB0C7';

      this.ctx.closePath();
      this.ctx.stroke();
      this.ctx.setLineDash([]);
    },

    drawCouplingA() {
      this.drawImage(getFromStorage(this.couplingA.render_canvas));
    },
    drawCouplingB() {
      this.drawImage(getFromStorage(this.couplingB.render_canvas), true);
    },

    drawRectangle(x, y, w, h, color) {
      this.ctx.beginPath();
      this.ctx.fillStyle = color;
      this.ctx.rect(x, y, w, h);
      this.ctx.closePath();
      this.ctx.fill();
      this.ctx.fillStyle = 'black';
    },

    hovering(x, y, w, h) {
      const factorX = this.canvas.width / this.canvas.getBoundingClientRect().width;
      const factorY = this.canvas.height / this.canvas.getBoundingClientRect().height;

      return this.mouseX <= (x + w) / factorX && this.mouseX >= (x / factorX) &&
          this.mouseY <= (y + h) / factorY && this.mouseY >= (y / factorY);
    },

    updateMousePosition(e) {
      if (this.canvas === undefined) return;
      const canvasBB = this.canvas.getBoundingClientRect();
      const canvasTop = canvasBB.top;
      const canvasLeft = canvasBB.left;

      this.mouseX = e.clientX - canvasLeft;
      this.mouseY = e.clientY - canvasTop;
    },

    openPopup(event) {
      if (event.target === this.canvas) {
        if (this.hovers.left.hovered) {
          this.$store.dispatch('build/hoses/setPopup', 'couplingA');
        } else if(this.hovers.right.hovered) {
          this.$store.dispatch('build/hoses/setPopup', 'couplingB');
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
    }),
    canvas() {
      return this.$refs.hoseCanvas;
    },
    ctx() {
      if (this.canvas === undefined) return;

      return this.canvas.getContext("2d");
    },
    hasRotation() {
      return (this.couplingA && this.couplingA.rotatable) || (this.couplingB && this.couplingB.rotatable);
    },
    isMobile() {
      return this.device === 'mobile';
    },
    hovers() {
      const hoverWidth = 350
      const leftTopOffset = (this.couplingA && this.couplingA.rotatable) ? 100 : (100 + (this.couplingB && this.couplingB.rotatable ? 100 : 0));
      const rightTopOffset = (this.couplingB && this.couplingB.rotatable) ? 100 : (100 + (this.couplingA && this.couplingA.rotatable ? 100 : 0));

      const left = {
        x: 0,
        y: leftTopOffset,
        w: hoverWidth,
        h: this.canvas.height - leftTopOffset,
      }

      const right = {
        x: this.canvas.width - hoverWidth,
        y: rightTopOffset,
        w: hoverWidth,
        h: this.canvas.height - rightTopOffset,
      }

      left.hovered = this.hovering(left.x, left.y, left.w, left.h);
      right.hovered = this.hovering(right.x, right.y, right.w, right.h);

      return {
        left,
        right
      };
    },
    hoveredCoupling() {
      if (!this.drawn) return false;

      if (this.hovers.left.hovered) {
        return this.couplingA;
      } else if (this.hovers.right.hovered) {
        return this.couplingB;
      }
    },
  },

  mounted() {
    this.draw();

    document.addEventListener('mousemove', this.updateMousePosition);
    document.addEventListener('click', this.openPopup);
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.updateMousePosition);
    document.addEventListener('click', this.openPopup);
  },
}
</script>

<style scoped lang="scss">
.canvas-container {
  margin-top: -50px;
  grid-column: 1/16;
  grid-row: 4/5;

  &.rotation {
    grid-column: 1/16;
    grid-row: 4/6;
  }

  &.mobile {
    margin-top: 0;
    grid-column: 1 / 11;
    grid-row: 2 / 3;
  }

  &.tablet {
    margin-top: -108px;
  }

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
